import { combineReducers } from "@reduxjs/toolkit";
import message from "./messageSlice";
import loader from "./loaderSlice";

const miscReducers = combineReducers({
	message,
	loader,
});

export default miscReducers;
